import { useAtom } from 'jotai';
import { useCallback, useEffect } from 'react';

import { localStorageAtom } from '@frontend/atoms';

export function useLocalstorageParam(
  key: string
): [string | null, (value?: string | null) => void] {
  const [lcAtomData, setLcAtomData] = useAtom(localStorageAtom);

  const setParamValue = useCallback(
    (value?: string | null) => {
      const currentLCData = localStorage.getItem(key);
      if (currentLCData !== value) {
        if (value === null || value === undefined) {
          localStorage.removeItem(key);
        } else {
          localStorage.setItem(key, value);
        }
      }
      setLcAtomData(prevData => ({
        ...prevData,
        [key]: value || null,
      }));
    },
    [key, setLcAtomData]
  );

  // Update state when tab becomes visible (in case localStorage changed in another tab)
  useEffect(() => {
    const initializeValue = () => {
      const currentValue = localStorage.getItem(key);
      if (currentValue !== lcAtomData[key]) {
        setParamValue(currentValue);
      }
    };
    const handleVisibility = () => {
      if (document.visibilityState === 'visible') {
        initializeValue();
      }
    };
    initializeValue();
    document.addEventListener('visibilitychange', handleVisibility);
    return () => document.removeEventListener('visibilitychange', handleVisibility);
  });

  return [lcAtomData[key], setParamValue];
}
